import React from "react";
import { Navbar } from "react-bootstrap";
import Container from 'react-bootstrap/Container';
import SiteHealth from "../Sites/SiteHealth";
import SiteHealthFilter from "../Sites/SiteHealthFilter";

import "./topnav.css";
import "./footer.css";

export default function Footer (props) {
  return (
    <Navbar fixed="bottom" className="footer-pane navbar-bg py-1 ">
      <Container>
      <div className="tour-sitehealth">
        <div className="footer-grid tour-numberofsites">
          <span className="caption footer-caption">Number of Sites:</span>
          <SiteHealth {...props} />
        </div>

        <div className="footer-spacer">|</div>

        <div className="footer-grid2 tour-periodselector">
          <span className="caption footer-caption">DCAP Contact Time Filter:</span>
          <span className="footer-content">
            <SiteHealthFilter {...props} />
          </span>
        </div>
      </div>
      </Container>
    </Navbar>
  )
}

